import React from 'react'
import {Card, Descriptions, Result, Tag} from "antd"
import ClubPlatformShopBind from "./ClubPlatformShopBind"
import ClubPlatformUnbind from "./ClubPlatformUnbind"
import ClubPlatformUnbindShop from "./ClubPlatformUnbindShop"
import ClubPlatformAuthRefresh from "./ClubPlatformAuthRefresh"
import moment from "moment"
import ClubPlatformAvatar from "./ClubPlatformAvator"


const initialState = {
    platform: {
        clubId: 0,
        order: 0,
        name: "",
        id: 0,
        isConsumable: false,
        isEnabled: false,
        createTime: "",
        updateTime: ""
    },
    value: {
        merchant: {
            platformMerchantId: "",
            name: "",
            id: 0,
            createTime: "",
            updateTime: ""
        },
        shop: {
            merchantId: 0,
            platformShopId: "",
            name: "",
            createTime: "",
            updateTime: "",
            id: 0
        },
        auth: {
            expiration: "",
            lastRefreshTime: "",
            remainRefreshCount: 0
        }
    }
}


const CLubPlatformAuthCardContext = React.createContext(initialState)


/**
 *
 * @param  props
 * @param {JSX.Element} descChildren
 * @param {JSX.Element[]} actionChildren
 * @param {JSX.Element} avatar
 * @return {JSX.Element}
 * @constructor
 */
const ClubPlatformAuthCard = ({props, descChildren, actionChildren, avatar}) => {

    return (
        <CLubPlatformAuthCardContext.Provider value={props}>
            <Card
                style={{width: 400}}
                title={
                    <div>
                        {avatar}
                        <span style={{marginLeft: "20px"}}>{props.platform.name}</span>
                    </div>
                }
                extra={<Tag color="blue">已授权</Tag>}
                actions={actionChildren}
            >
                {descChildren}
            </Card>
        </CLubPlatformAuthCardContext.Provider>
    )
}


ClubPlatformAuthCard.Avatar = () => {
    const {platform} = React.useContext(CLubPlatformAuthCardContext)
    return <ClubPlatformAvatar platformId={platform.id}/>
}


ClubPlatformAuthCard.RefreshAuth = () => {
    const {platform, value} = React.useContext(CLubPlatformAuthCardContext)
    return <ClubPlatformAuthRefresh merchantId={value.merchant.id}/>
}

ClubPlatformAuthCard.BindOrUnbindShop = () => {
    const {platform, value} = React.useContext(CLubPlatformAuthCardContext)

    return (
        value.shop ? <ClubPlatformUnbindShop platformId={platform.id}/> :
            <ClubPlatformShopBind platformId={platform.id} merchantId={value.merchant.id}/>
    )
}

ClubPlatformAuthCard.UnbindStore = () => {
    const {platform} = React.useContext(CLubPlatformAuthCardContext)
    return <ClubPlatformUnbind platformId={platform.id}/>
}

ClubPlatformAuthCard.MeiTuanDec = () => {
    const {
        value
    } = React.useContext(CLubPlatformAuthCardContext)

    return (
        <div style={{height: 150}}>
            <Result style={{padding:"16px"}} status={"success"} title={"已成功绑定"}></Result>
        </div>
    )
}

ClubPlatformAuthCard.DouYinDec = () => {
    const {
        value
    } = React.useContext(CLubPlatformAuthCardContext)

    return (
        <div style={{height: 150}}>
            <Descriptions column={1}>
                <Descriptions.Item label="商家Id">
                    {value.merchant.platformMerchantId}
                </Descriptions.Item>
                <Descriptions.Item label="关联店铺">
                    {value.shop?value.shop.name:"暂未关联店铺"}
                </Descriptions.Item>
                <Descriptions.Item label="店铺Id">
                    {value.shop?value.shop.platformShopId:"暂未关联店铺"}
                </Descriptions.Item>
            </Descriptions>
        </div>
    )
}


export default ClubPlatformAuthCard



// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformAuthCard.js